import apiClient from "../api/apiClient"

export interface ImportRow {
  rowNum: number
  action: "create" | "update" | "error" | "warning"
  reason?: string
  warning?: string | null
  matchedId?: string | null
  data: Record<string, unknown>
}

export interface ImportPreviewResponse {
  summary: {
    total: number
    toCreate: number
    toUpdate: number
    errors: number
  }
  rows: ImportRow[]
}

export interface ImportConfirmResponse {
  message: string
  summary: {
    created: number
    updated: number
    skipped: number
  }
}

const MULTIPART_HEADERS = { "Content-Type": "multipart/form-data" }
const PREVIEW_TIMEOUT = 30_000
const CONFIRM_TIMEOUT = 60_000

export const importService = {
  async previewCustomers(file: File): Promise<ImportPreviewResponse> {
    const formData = new FormData()
    formData.append("file", file)
    const response = await apiClient.post<ImportPreviewResponse>(
      "/admin/import/customers/preview",
      formData,
      { headers: MULTIPART_HEADERS, timeout: PREVIEW_TIMEOUT },
    )
    return response.data
  },

  async confirmCustomers(file: File): Promise<ImportConfirmResponse> {
    const formData = new FormData()
    formData.append("file", file)
    const response = await apiClient.post<ImportConfirmResponse>(
      "/admin/import/customers/confirm",
      formData,
      { headers: MULTIPART_HEADERS, timeout: CONFIRM_TIMEOUT },
    )
    return response.data
  },

  async previewSkus(file: File): Promise<ImportPreviewResponse> {
    const formData = new FormData()
    formData.append("file", file)
    const response = await apiClient.post<ImportPreviewResponse>(
      "/admin/import/skus/preview",
      formData,
      { headers: MULTIPART_HEADERS, timeout: PREVIEW_TIMEOUT },
    )
    return response.data
  },

  async confirmSkus(file: File): Promise<ImportConfirmResponse> {
    const formData = new FormData()
    formData.append("file", file)
    const response = await apiClient.post<ImportConfirmResponse>(
      "/admin/import/skus/confirm",
      formData,
      { headers: MULTIPART_HEADERS, timeout: CONFIRM_TIMEOUT },
    )
    return response.data
  },
}
